import './Legal.css';

export default function DeleteAccount() {
  return (
    <div className="legal-page">
      <nav className="legal-nav">
        <a href="/" className="legal-nav-logo"><span className="logo-o">O</span>urStory</a>
      </nav>
      <div className="legal-content container">
        <div className="legal-header">
          <a href="/" className="legal-back">← Back</a>
          <h1>Delete Your Account</h1>
          <p className="legal-intro">You can delete your OurStory account and all associated data directly from within the app.</p>
        </div>
        <div className="legal-section">
          <h2>How to delete your account</h2>
          <p>1. Open the OurStory app on your device<br/>
          2. Tap your username in the top navigation bar<br/>
          3. Tap <strong>Settings</strong><br/>
          4. Scroll to the bottom and tap <strong>Delete account</strong><br/>
          5. Confirm deletion when prompted</p>
        </div>
        <div className="legal-section">
          <h2>What gets deleted</h2>
          <p>When you delete your account, the following data is permanently removed: your account profile, your alias, your email address, all stories you have shared, your friends list, your notification preferences, and all other personal data associated with your account. This action cannot be undone.</p>
        </div>
        <div className="legal-section">
          <h2>Need help?</h2>
          <p>If you are unable to access the app or need assistance deleting your account, please contact us at <a href="mailto:info@theourstoryapp.com" style={{color: '#b8d4b8'}}>info@theourstoryapp.com</a> and we will delete your account within 30 days.</p>
        </div>
      </div>
      <footer className="legal-footer">
        <p>© 2026 OurStory · <a href="mailto:info@theourstoryapp.com">info@theourstoryapp.com</a></p>
      </footer>
    </div>
  );
}
